/**
 * @file: DepartmentMegbox.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 旷世魔方设备与食堂管理
 */
import request from '@/utils/request'

/**
 * 创建/修改食堂与设备关联关系(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function megboxDepartmentmegboxCreateorupdate(data) {
  return request({
    type: 'device',
    url: 'megbox/departmentMegbox/createOrUpdate',
    method: 'post',
    data
  })
}

/**
 * 删除食堂与设备关联关系(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function megboxDepartmentmegboxDelete(data) {
  return request({
    type: 'device',
    url: 'megbox/departmentMegbox/delete',
    method: 'post',
    data
  })
}

/**
 * 查询食堂与设备关联关系(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function megboxDepartmentmegboxList(data) {
  return request({
    type: 'device',
    url: 'megbox/departmentMegbox/list',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/DepartmentMegbox.js